import { UseFormRegisterReturn } from 'react-hook-form'

import GradientWrapper from '@/common/GradientWrapper'
import { UiTextarea } from '@/ui/UiTextarea'

export default function ProposalJsonEditor({
  rawJsonTextField,
  errorMessage,
  isDisabled,
}: {
  rawJsonTextField: UseFormRegisterReturn
  errorMessage?: string
  isDisabled: boolean
}) {
  return (
    <div className='space-y-2'>
      <GradientWrapper>
        <UiTextarea
          {...rawJsonTextField}
          disabled={isDisabled}
          className='bg-input text-foreground min-h-70 resize-none rounded-lg font-mono text-xs'
          placeholder={`{
  "messages": [
    { "@type": "/cosmos.bank.v1beta1.MsgSend" }
  ]
}`}
        />
      </GradientWrapper>

      {errorMessage && <p className='text-xs text-red-400'>{errorMessage}</p>}
    </div>
  )
}
